import React, { useState, useEffect } from 'react';
import "./AdminPanel.css";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import AdminSidebar from "./AdminSidebar";
import AdministratorSidebar from "./AdministratorSidebar";
import UserSidebar from "./UserSidebar";

const ThirdParty = () => {
    const navigate = useNavigate();
    const [userType, setUserType] = useState("");
    const [userName, setUserName] = useState("");
    const [userFullName, setUserFullName] = useState("");
    const [cars, setCars] = useState([]);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [highlightStatus, setHighlightStatus] = useState({});
    const itemsPerPage = 10;

    useEffect(() => {
        // Get user data from localStorage
        const storedUserType = localStorage.getItem("usertype");
        const storedUserName = localStorage.getItem("userName");
        const storedFName = localStorage.getItem("fname");
        const storedLName = localStorage.getItem("lname");

        console.log(storedUserType); // Log to ensure it's retrieved correctly
        if (!storedUserType) {
            navigate("/login"); // Redirect if not logged in
        } else {
            setUserType(storedUserType);
            setUserName(storedUserName);
            // Combine first and last name if available
            if (storedFName && storedLName) {
                setUserFullName(`${storedFName} ${storedLName}`);
            } else if (storedFName) {
                setUserFullName(storedFName);
            } else {
                setUserFullName(storedUserName);
            }
        }
    }, [navigate]);

    // Logout function
    const logout = () => {
        // Clear session data from localStorage
        localStorage.removeItem("token");
        localStorage.removeItem("email");
        localStorage.removeItem("userName");
        localStorage.removeItem("usertype");
        localStorage.removeItem("fname");
        localStorage.removeItem("lname");

        // Redirect to login page after logout
        navigate("/login");
    };

    useEffect(() => {
        fetchCars();
    }, []);

    const fetchCars = async () => {
        try {
            const response = await axios.get('https://api.saadmotors.com/fetch_cars_thirdparty.php');
            console.log('API Response:', response.data); // Debug the response
            // Ensure response.data is an array before setting state
            if (Array.isArray(response.data)) {
                setCars(response.data);
                setError(null);
            } else {
                console.error('API did not return an array:', response.data);
                setCars([]);
                setError(response.data.error || 'Failed to load vehicles: Invalid API response');
            }
        } catch (error) {
            console.error('Error fetching cars:', error);
            setCars([]);
            setError('Failed to load vehicles: Network or server error');
        }
    };

    useEffect(() => {
        if (cars.length > 0) {
            const stockIds = cars.map(car => car.stock_id).join(',');
            const fetchHighlight = async () => {
                try {
                    const response = await axios.get(`https://api.saadmotors.com/check_highlight.php?stock_ids=${stockIds}`);
                    setHighlightStatus(response.data);
                } catch (error) {
                    console.error('Error fetching highlight status:', error);
                }
            };
            fetchHighlight();
        }
    }, [cars]);

    const handleEdit = (id) => {
        navigate(`/edit-vehicleThirdParty/${id}`);
    };

    const handleAllocate = (stock_id) => {
        navigate(`/allocate-vehicle/${stock_id}`);
    };

    const handleImageClick = (id) => {
        navigate(`/vehicle-images/${id}`);
    };

    const handleViewDocs = (id) => {
        navigate(`/view-docs/${id}`);
    };

    const handleDelete = async (id) => {
        try {
            // Confirm deletion with the user
            const confirmDelete = window.confirm('Are you sure you want to delete this car?');
            if (!confirmDelete) return;

            // Send a DELETE request to the backend
            const response = await axios.delete(`https://api.saadmotors.com/delete_car_ThirdParty?id=${id}`);

            // Log the response for debugging
            console.log('Delete response:', response.data);

            // Display a success message
            if (response.data.message) {
                alert(response.data.message); // Show success message
            } else if (response.data.error) {
                alert(response.data.error); // Show error message
            }

            // Refresh the car list after deletion
            fetchCars();
            // Reset to first page if the current page becomes empty
            const totalPages = Math.ceil(cars.length / itemsPerPage);
            if (currentPage > totalPages && totalPages > 0) {
                setCurrentPage(totalPages);
            }
        } catch (error) {
            console.error('Error deleting car:', error);
            alert('An error occurred while deleting the car. Please check the console for details.');
        }
    };

    const handleInvoice = (id) => {
        navigate(`/invoice/${id}`);
    };

    // Pagination logic
    const totalItems = cars.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const currentCars = cars.slice(startIndex, endIndex);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
        window.scrollTo(0, 0); // Scroll to top on page change
    };

    return (
        <div className="admin-container">
            {/* Conditionally Render Sidebar */}
            <div className="sidebar-container">
                {userType === "administrator" && <AdministratorSidebar />}
                {userType === "admin" && <AdminSidebar />}
                {userType === "user" && <UserSidebar />}
            </div>

            <div className="admin-content">
                <div className="adminnavbar">
                    <h1>Welcome to the Admin Panel, {userFullName}</h1>
                    {/* Logout button */}
                    <button onClick={logout} className="logoutbtn">
                        Logout
                    </button>
                </div>

                <div className="mainsection">
                    <h3>View All Third Party  Vehicles</h3>
                </div>

                <div className="container">
                    {error && (
                        <div className="alert alert-danger" role="alert">
                            {error}
                        </div>
                    )}
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th style={{ textAlign: "center" }}>Image</th>
                                <th style={{ textAlign: "center" }}>Stock ID</th>
                                <th style={{ textAlign: "center" }}>Vehicle Details</th>
                                <th style={{ textAlign: "center" }}>Chassis #</th>
                                <th style={{ textAlign: "center" }}>Sold Price</th>
                                <th style={{ textAlign: "center" }}>Allocated</th>
                                <th style={{ textAlign: "center" }}>Balance</th>
                                <th style={{ textAlign: "center" }}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentCars.length > 0 ? (
                                currentCars.map((car) => (
                                    <tr key={car.id}>
                                        <td style={{ textAlign: "center" }}>
                                            <img
                                                src={`https://api.saadmotors.com/${car.images}`}
                                                alt="Car"
                                                style={{ width: '90px', height: 'auto', cursor: 'pointer', border:highlightStatus[car.stock_id] ? '7px solid #0d6efd' : 'transparent' }}
                                                onClick={() => handleImageClick(car.id)}
                                            />
                                        </td>
                                        <td style={{ textAlign: "center" }}>{car.stock_id}</td>
                                        <td style={{ textAlign: "center" }}>{car.maker} {car.model} {car.year}</td>
                                        <td style={{ textAlign: "center" }}>{car.vin}</td>
                                        <td style={{ textAlign: "right" }}>{car.sold_price}</td>
                                        <td style={{ textAlign: "right" }}>{parseFloat(car.allocated_amount).toFixed(2)}</td>
                                        <td style={{ textAlign: "right" }}>{car.sold_price - car.allocated_amount}</td>
                                        <td style={{ textAlign: "center" }}>
                                            <span title="Edit">
                                                <svg xmlns="http://www.w3.org/2000/svg" onClick={() => handleEdit(car.id)} style={{ color: "#ffffff", marginRight: "10px", backgroundColor: "#0168FA", padding: "3px" }} width="20" height="20" alt="Edit" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                                                    <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                                    <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z" />
                                                </svg>
                                            </span>

                                            <span title="Allocate">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    onClick={() => handleAllocate(car.stock_id)}
                                                    style={{ color: "#ffffff", backgroundColor: "#DB2B2A", marginRight: "10px", padding: "1px" }}
                                                    width="20"
                                                    height="20"
                                                    fill="currentColor"
                                                    className="bi bi-cash"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path d="M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4" />
                                                    <path d="M0 4a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1zm3 0a2 2 0 0 1-2 2v4a2 2 0 0 1 2 2h10a2 2 0 0 1 2-2V6a2 2 0 0 1-2-2z" />
                                                </svg>
                                            </span>

                                            <span title="PDF">
                                                <svg xmlns="http://www.w3.org/2000/svg" onClick={() => handleViewDocs(car.id)} style={{ color: "#ffffff", backgroundColor: "#F29803", marginRight: "10px", padding: "2px" }} width="20" height="20" fill="currentColor" className="bi bi-filetype-pdf" viewBox="0 0 16 16">
                                                    <path fillRule="evenodd" d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM1.6 11.85H0v3.999h.791v-1.342h.803q.43 0 .732-.173.305-.175.463-.474a1.4 1.4 0 0 0 .161-.677q0-.375-.158-.677a1.2 1.2 0 0 0-.46-.477q-.3-.18-.732-.179m.545 1.333a.8.8 0 0 1-.085.38.57.57 0 0 1-.238.241.8.8 0 0 1-.375.082H.788V12.48h.66q.327 0 .512.181.185.183.185.522m1.217-1.333v3.999h1.46q.602 0 .998-.237a1.45 1.45 0 0 0 .595-.689q.196-.45.196-1.084 0-.63-.196-1.075a1.43 1.43 0 0 0-.589-.68q-.396-.234-1.005-.234zm.791.645h.563q.371 0 .609.152a.9.9 0 0 1 .354.454q.118.302.118.753a2.3 2.3 0 0 1-.068.592 1.1 1.1 0 0 1-.196.422.8.8 0 0 1-.334.252 1.3 1.3 0 0 1-.483.082h-.563zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638z" />
                                                </svg>
                                            </span>

                                            <span title="Invoice">
                                                <svg xmlns="http://www.w3.org/2000/svg" onClick={() => handleInvoice(car.id)} style={{ color: "#ffffff", backgroundColor: "#33cc33", padding: "2px" }} width="20" height="20" fill="currentColor" class="bi bi-receipt-cutoff" viewBox="0 0 16 16">
                                                    <path d="M3 4.5a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5M11.5 4a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1z" />
                                                    <path d="M2.354.646a.5.5 0 0 0-.801.13l-.5 1A.5.5 0 0 0 1 2v13H.5a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1H15V2a.5.5 0 0 0-.053-.224l-.5-1a.5.5 0 0 0-.8-.13L13 1.293l-.646-.647a.5.5 0 0 0-.708 0L11 1.293l-.646-.647a.5.5 0 0 0-.708 0L9 1.293 8.354.646a.5.5 0 0 0-.708 0L7 1.293 6.354.646a.5.5 0 0 0-.708 0L5 1.293 4.354.646a.5.5 0 0 0-.708 0L3 1.293zm-.217 1.198.51.51a.5.5 0 0 0 .707 0L4 1.707l.646.647a.5.5 0 0 0 .708 0L6 1.707l.646.647a.5.5 0 0 0 .708 0L8 1.707l.646.647a.5.5 0 0 0 .708 0L10 1.707l.646.647a.5.5 0 0 0 .708 0L12 1.707l.646.647a.5.5 0 0 0 .708 0l.509-.51.137.274V15H2V2.118z" />
                                                </svg>
                                            </span>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="8" style={{ textAlign: "center", padding: "20px" }}>
                                        {error ? 'Error loading vehicles' : 'No vehicles found'}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>

                    {/* Pagination Controls */}
                    {totalItems > itemsPerPage && (
                        <nav aria-label="Page navigation">
                            <ul className="pagination justify-content-center">
                                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                    <button
                                        className="page-link"
                                        onClick={() => handlePageChange(currentPage - 1)}
                                        disabled={currentPage === 1}
                                    >
                                        Previous
                                    </button>
                                </li>

                                {[...Array(totalPages).keys()].map(page => (
                                    <li
                                        key={page + 1}
                                        className={`page-item ${currentPage === page + 1 ? 'active' : ''}`}
                                    >
                                        <button
                                            className="page-link"
                                            onClick={() => handlePageChange(page + 1)}
                                        >
                                            {page + 1}
                                        </button>
                                    </li>
                                ))}

                                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                    <button
                                        className="page-link"
                                        onClick={() => handlePageChange(currentPage + 1)}
                                        disabled={currentPage === totalPages}
                                    >
                                        Next
                                    </button>
                                </li>
                            </ul>
                        </nav>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ThirdParty;